{
    "ShowHeaderRowLabel": "Afficher la rangée d'en-tête :",
    "ShowFooterRowLabel": "Afficher la rangée de pied de page :",
    "ShowContentRowsLabel": "Afficher les rangées de contenu :",
    "ShowSpacerRowsLabel": "Montrer la ou les rangées d'espacement :",
    "NAME": "ReportContentRowsSettingsLanguage"
}